module.exports = __webpack_public_path__ + "img/画板 1 拷贝 20.7d444ceb.jpg";